import {generatePropertyQAndAReport} from "./ApiTasks";
import {DownloadFile} from "./DownloadFile";

export const DownloadPropertyReport = async (propertyId) => {

    let report = {};
    try {
        report = await generatePropertyQAndAReport(propertyId);
    } catch (error) {
        console.error('Could not generate property Q&A report for property #', propertyId, error);
        return;
    }

    await DownloadFile(report.result.filename, report.result.file);
}
